import indiaPic from "@/public/images/artists/india.png";
import { Artist } from "@/types/types";

export const india = {
  id: "120",
  name: "India",
  image: indiaPic,
  description: `India has airy vocals with a gentle vocal timbre that lend themselves beautifully to ethereal melodies, making her a perfect fit for indie tunes and warm harmonies.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Findia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Indie", "Ethereal", "Airy"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 59,
        high: 74,
      },
    },
  },
} as const satisfies Artist;
